import { AfterViewInit, Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { LoaderComponent } from './core/components/loader/loader.component';
import { ToastComponent } from './core/components/toast/toast.component';
import { AuthenticationService } from './core/auth/services/authentication.service';
import { GoogleMapsLoaderService } from './shared/services/google-maps-loader.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent, ToastComponent],
    templateUrl: './app.component.html'
})
export class AppComponent implements AfterViewInit {
  title = 'adr-client';

  constructor(
    public _authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly googleMapsLoader: GoogleMapsLoaderService,
  ) {
    (globalThis as any).versionDate = environment.versionDate;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const currentUrl = this.router.url;

      this._authenticationService.onGetGoogleAPIKey.subscribe(
        (isSuccessLogin) => {
          if (isSuccessLogin && currentUrl !== '/login') {
            this.getGoogleAPIKey();
          }
        },
      );

      if (
        this._authenticationService.currentUserValue &&
        Object.keys(this._authenticationService.currentUserValue).length > 0 &&
        currentUrl !== '/login'
      ) {
        this.getGoogleAPIKey();
      }

      console.log(currentUrl);
    });
  }

  getGoogleAPIKey() {
    this._authenticationService.getGoogleAPIKey().subscribe((result) => {
      let key = result.data.propertyValue;      
      // Switched to using the centralized loader service
      this.googleMapsLoader.loadScript(key).then(() => {
      }).catch((error) => {
        console.error('Failed to load Google Maps API:', error);
      });
    });
  }
}
